export const formatCompanyName = (value) => {
    if (value) {
        return value;
    }

    return "Name Withheld";
};

export const defaultDataGridProperties = {
    enableTopToolbar: false,
    enableColumnResizing: true,
    enableDensityToggle: false,
    enableBottomToolbar: false,
    enableFilters: false,
    layoutMode: "grid",
    positionToolbarAlertBanner: "bottom",
    positionExpandColumn: "last",
    positionPagination: "top",
    autoResetPageIndex: false,
    localization: {
        noRecordsToDisplay: 'No records to display, please expand your search criteria'
    },
    muiPaginationProps: {
        showRowsPerPage: false,
    },
    muiTablePaperProps: {
        sx: (theme) => ({
            boxShadow: "unset",
            border: `1px solid ${theme.palette.contrastGrey.main}`,
        })
    },
    muiTableHeadRowProps: {
        sx: {
            backgroundColor: 'contrastGrey.light',
        }
    },
    muiTableHeadCellProps: {
        sx: (theme) => ({
            borderRight: `1px solid ${theme.palette.contrastGrey.main}`,
            "& .MuiDivider-root": {
                borderStyle: 'none',
            },
        }),
    },
    initialState: {
        density: "compact",
        pagination: {pageIndex: 0, pageSize: 20},
    },
};

export const defaultDataGridWithSelectProperties = {
    ...defaultDataGridProperties,
    getRowId: (row) => row.id,
    enableRowSelection: true,
    enableExpandAll: false,
    selectAllMode: "all",
    mrtTheme: {
        selectedRowBackgroundColor: "#eef4fb",
    },
    displayColumnDefOptions: {
        'mrt-row-select': {
            maxSize: 20,
            visibleInShowHideMenu: false,
        },
        'mrt-row-expand': {
            header: "",
            maxSize: 20,
            visibleInShowHideMenu: false,
        },
    },
    muiTableBodyRowProps: ({row, table}) => ({
        onClick: () => {
            const openPanels = table.getExpandedRowModel().rows.reduce((acc, row) => {
                acc[row.id] = row.getIsExpanded();
                return acc;
            }, {});
            openPanels[row.id] = !row.getIsExpanded();
            table.setExpanded(openPanels);
        }
    })
};

export const copyToClipboard = (data, openSnackBar) => {
    if (typeof ClipboardItem && navigator.clipboard.writeText) {
        const text = new ClipboardItem({
            "text/plain": new Blob([data], {type: "text/plain"})
        });
        navigator.clipboard.write([text]).then(() => {
            openSnackBar(true);
        });
    } else {
        navigator.clipboard.writeText(data).then(() => {
            openSnackBar(true);
        });
    }
};
